/*
 * @Author: bbqin
 * @Date: 2023-08-02 09:52:30
 * @LastEditTime: 2023-08-02 16:35:11
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\Form\components\container\FormCardItem.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';
import Hyperlink from '../../../Hyperlink';
import { formatDatetime, getMultiLang, changeTime, isNullOrVoid, formatNumber, formatAcuracyRound, getRandomPassword, getLangCode } from '@platform/api';
import { Tooltip, Tag, Hexagon } from '@platform/base';
import { getMainId } from '../../utils';

const defaultColor = new Set(['#111111', '#555555', '#111', '#555']);
export default class FormCardItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return this.renderCardItem();
    }

    renderCardItem = () => {
        let { moduleId, column, cardItem = null, cardItemContent, areaCode, itemCode, meta = {}, currentMeta, attrcode, className = '', pageScope, pageId, store, forceHideLink, langJson={} } = this.props;
        let item = {};
        let renderDisplay = '';
        let renderTooltip = false;
        let json = {};
        if (cardItem) {
            item = { ...cardItem };
            if (Object.prototype.toString.call(cardItemContent).slice(8, -1) === 'Object') {
                // 解析设计器传过来的 标签
                let { color, borderRadius, fontColor, border, value, ...others } = cardItemContent;
                // renderDisplay = <Tag color={color} style={{ borderRadius: borderRadius ? '10px' : '3px', backgroundColor: color, color: fontColor, border }} {...others}>{value}</Tag>
                renderDisplay = <Hexagon text={value} backgroundColor={color} borderRadius={borderRadius} {...others} />;
            } else {
                renderDisplay = langJson['page-form-0016'] || cardItemContent || '内容';
            }
        } else {
            // 运行时使用
            // let currentItem = currentMeta.items.find(item => item.attrcode === attrcode);
            // let storeField = store.getCardItem(moduleId, attrcode);
            // if(storeField){
            //     let { disabled, visible, required, verify, color, contentcolor } = storeField;
            //     currentItem = { ...currentItem, disabled, visible, required, verify, color, contentcolor };
            // }
            item = { ...column };
            renderDisplay = this.renderItemDisplay(item, areaCode || currentMeta.code, meta, pageScope, pageId);
            // 动态字段值为空时，不显示label 这里以后可能还会改 留着注释
            // UE 刘慧敏 最终结论（先在这里打个问号？？？）
            // 元数据字段的空值不区分是否显示字段名称，都统一给XX：，非空值区分是否显示字段名称
            // 非元数据字段空值不展示字段名称，非空值区分是否显示字段名称
            if (Array.isArray(renderDisplay) && renderDisplay[1] == '' && item.metapath) {
                item.ishidefieldname = false;
            }
            if (Array.isArray(renderDisplay) && renderDisplay[1] == '' && !item.metapath) {
                item.ishidefieldname = true;
            }
            // 动态字段值为空时，不显示label 这里以后可能还会改 留着注释
            renderTooltip = true;
            // 取多语
            let mainFormId = getMainId(areaCode || currentMeta.code, meta);
            json = pageScope?.formDataSource?.[mainFormId]?.getInnerHooks()?.getJson();
        }
        // ishidefieldname 为 true 不显示label renderDisplay 为空不显示content
        let showContent = item.ishidefieldname && (undefined === renderDisplay || null === renderDisplay || '' === renderDisplay);
        const color = defaultColor.has(item.color) ? {} : { color: item.color };
        const contentColor = defaultColor.has(item.contentcolor) ? {} : { color: item.contentcolor };

        return showContent ? null : <span
            className={`card-col card-${item.itemtype} card-${item.attrcode} ${className} ${item.cardItemClassName || ''}`}
            key={item.attrcode}
        >
            {!item.ishidefieldname && <span
                className='card-col-label'
                style={{
                    fontSize: item.fontsize,
                    ...color,
                }}>
                {item.label}{this.renderHelpIcon(item.tooltips, renderTooltip)}：
            </span>}
            {/* 非空数据显示 */}
            <span
                className='card-col-display font-family-HarmonyOS'
                style={{
                    fontSize: item.fontsize,
                    ...contentColor,
                }}
            >
                {renderDisplay}{item.ishidefieldname && item.metapath ? this.renderHelpIcon(item.tooltips, renderTooltip) : null}
            </span>
        </span>;
    }

    //渲染提示图标
    renderHelpIcon = (tooltips, renderTooltip) => {

        return (
            renderTooltip && tooltips ? <Tooltip
                placement="top"
                overlay={tooltips}
            >
                <span className='form-item-msg'>
                    <i className="iconfont icon-shuoming1 icon-msg-unhover" />
                    <i className="iconfont icon-shuoming2 icon-msg-hover " />
                </span>
            </Tooltip> : null
        );
    }

    getMetaItem = (areaCode, itemCode, meta) => {
        let item = meta[areaCode]?.items.find(item => item.attrcode === itemCode) || {};
        return item;
    }

    renderItemDisplay = (item, areaCode, meta, pageScope, pageId) => {
        let mainFormId = getMainId(areaCode, meta);
        let row = pageScope?.formDataSource?.[mainFormId]?.getAllFormValue();
        let json = pageScope?.formDataSource?.[mainFormId]?.getInnerHooks()?.getJson();
        //处理前缀和后缀
        let displayTpl = item.displayTpl || '';
        let prefix = displayTpl.split('|')[0] || '';
        let suffix = displayTpl.split('|')[1] || '';
        prefix = this.handleFix(prefix, row, mainFormId, pageId, areaCode, meta, json, pageScope);
        suffix = this.handleFix(suffix, row, mainFormId, pageId, areaCode, meta, json, pageScope);
        //如果有前缀，给前缀加个间距，先用空格代替
        // if (prefix.length) {
        //     prefix.push(' ');
        // }
        // if (suffix.length) {
        //     prefix.unshift(' ');
        // }
        let selfDis = this.getItemsDom(row, item, mainFormId, pageId, json);

        return [...prefix, selfDis, ...suffix];
    }
    handleFix = (display, row, mainFormId, pageId, areaCode, meta, json, pageScope) => {
        let match = display.match(/\$\{[^\s}]+\}/g);
        let splitfix = display.split(/\$\{[^\s}]+\}/);
        if (Array.isArray(match)) {
            match = match.map(item => {
                let code = item.replace('${', '').replace('}', '');
                // let metaItem = this.getMetaItem(areaCode, code, meta);
                let metaItem = pageScope?.formDataSource?.[mainFormId]?.getInnerHooks()?.getFormItem(code) || {};
                let fixDisplay = this.getItemsDom(row, metaItem, mainFormId, pageId, json);
                return fixDisplay;
            });
            return this.joinArr(match, splitfix);
        }
        return [display];
    }

    //合并两个数组
    joinArr = (ary, ary2) => {
        let itemAry = [];
        let minLength = ary.length;
        for (let i = 0; i < minLength; i++) {
            //将数组放入临时数组中
            itemAry.push(ary2[i]);
            itemAry.push(ary[i]);
        }
        //itemAry和多余的新数组拼接起来并返回。
        return itemAry.concat(ary2.slice(minLength));

    }

    getItemsDom = (data, item, mainFormId, pageId, json) => {
        let {
            itemtype, showFractile, isconverttimezones,
            attrcode, hyperlinkflag, areacode, render,
            datatype, hyperlinktype, hyperlinkname, hyperlinkurl,
            label, ishidefieldname = true, metapath, designlabelcontent, fontsize,
        } = item;
        const { forceHideLink } = this.props;
        let values = data?.[attrcode] || {};
        // 自定义render
        if (typeof render === 'function') {
            return render(values, data);
        }
        let value = '';
        // switch
        if (itemtype === 'checkbox_switch' || itemtype === 'switch') {
            values = {
                ...values,
                display: values.value ? (json?.["page-form-0007"] || '是') : (json?.["page-form-0004"] || '否'),
            };
        }
        // 元数据与非元数据
        if (metapath) {
            value = values.display || values.value || '';
            if (value === '') {
                return value;
            }
        } else {
            // 动态字段也就是非元数据 值为空时不显示
            value = values.display || values.value || '';
            if (value === '') {
                return value;
            }
        }

        // 数值
        if (itemtype === 'number') {
            let scale = values.scale;
            if (scale === undefined || scale === null || scale == '-1' || scale == -1) {
                scale = item.scale;
            }
            if (scale === undefined || scale === null || scale == '-1' || scale == -1) {
                scale = 0;
            }
            showFractile = typeof (showFractile) === 'boolean' ? !showFractile : false;
            value = formatNumber(formatAcuracyRound(value, Number(scale), showFractile), true, !showFractile);
        }

        // 日期
        if (values.value) {
            switch (itemtype) {
                case 'datetimepicker':
                case 'NCTZDatePickClientTime':
                    value = changeTime(value, 'YYYY-MM-DD HH:mm:ss', isconverttimezones);
                    value = formatDatetime(value, 'datetime');
                    break;
                case 'NCTZDatePickerStart':
                case 'NCTZDatePickerEnd':
                case 'NCTZDatePickClientHourTime':
                case 'datepicker':
                    value = changeTime(value, 'YYYY-MM-DD', isconverttimezones);
                    value = formatDatetime(value, 'date');
                    break;
                case 'datePickerNoTimeZone':
                    value = formatDatetime(value, 'date');
                    break;
                case 'timepicker':
                    value = formatDatetime(value, 'time');
                    break;
            }
        }
        let valueDom = value;
        // 标签   
        if ((itemtype === 'select' || itemtype === 'refer') && designlabelcontent && (values.display || values.value)) {
            try {
                let option = JSON.parse(designlabelcontent);
                // NCC-340984 designlabelcontent 中的 item.key 是个string，  需要转一下 value 
                let renderItem = option.find(item => item.key === String(values.value));
                // renderItem 匹配到字段 渲染成标签 否则 普通渲染
                if (renderItem) {
                    let { value, borderRadius, color, ...others } = renderItem;
                    valueDom = <Hexagon text={values.display || value} backgroundColor={color} borderRadius={borderRadius} {...others} />;
                } else {
                    valueDom = values.display;
                }
            } catch (error) {
                valueDom = values.display;
            }
        }

        // 超链接
        if (forceHideLink && hyperlinkflag) {
            // 列设置里不能渲染超链接
            valueDom = Hyperlink.getHyperlinkValue({
                datatype,
                hyperlinkflag,
                hyperlinktype,
                hyperlinkname,
                hyperlinkurl,
                value: value,
                browse: true,
            });
        } else if (hyperlinkflag) {
            valueDom = <Hyperlink
                datatype={datatype}
                hyperlinkflag={hyperlinkflag}
                hyperlinktype={hyperlinktype}
                hyperlinkname={hyperlinkname}
                hyperlinkurl={hyperlinkurl}
                value={values.display}
                browse={true}
                areaCode={mainFormId}
                pageId={pageId}
                attrCode={attrcode}
                dataId={values.value}
                className={'form-hyperlink'}
                fontSize={fontsize}
            >{values.display}</Hyperlink>;
        }

        return valueDom;
    };
}